export enum StiggFeature {
  SEATS = 'feature-seats',
  EVENT_LOG = 'feature-event-log',
  AWS_MARKETPLACE_INTEGRATION = 'feature-aws-marketplace-integration',
  BIGQUERY_INTEGRATION = 'feature-bigquery-integration',
  SNOWFLAKE_INTEGRATION = 'feature-snowflake-integration',
  SALESFORCE_INTEGRATION = 'feature-salesforce-integration',
  RBAC = 'feature-rbac',
  AUTHORIZED_DOMAIN = 'feature-authorized-domain',
  SSO_SAML = 'feature-sso-saml',
}
